/** Shared score → CSS class helpers for assessment cards */

/** Convert internal rating enum to display name (YELLOW → ORANGE) */
export function displayRating(rating: string): string {
  return rating === 'YELLOW' ? 'ORANGE' : rating;
}

export function ratingClass(rating: string): string {
  if (rating === 'GREEN') return 'green';
  if (rating === 'RED') return 'red';
  return 'orange';
}

export function scoreClass(score: number, max: number): string {
  const pct = (score / max) * 100;
  if (pct >= 70) return 'val-green';
  if (pct >= 45) return 'val-orange';
  return 'val-red';
}

export function scoreBadge(score: number, max: number): string {
  const pct = (score / max) * 100;
  if (pct >= 70) return 'bg-green';
  if (pct >= 45) return 'bg-orange';
  return 'bg-red';
}

export function scoreBadgeLabel(score: number, max: number): string {
  const pct = (score / max) * 100;
  if (pct >= 70) return 'Green';
  if (pct >= 45) return 'Orange';
  return 'Red';
}

export function barColor(score: number, max: number): string {
  const pct = (score / max) * 100;
  if (pct >= 70) return '#0F6E56';
  if (pct >= 45) return '#E06820';
  return '#A32D2D';
}
